<template lang="pug">
v-container.py-10.d-flex.flex-column.align-center
  grid-container.align-center(
    cols="auto",
    cols-md="340px 500px",
    gap-md="20px"
  )
    div
      .text-h4.font-weight-bold.primary--text(v-html="title")
      .text-body-1.font-weight-bold.mt-3(v-html="content.text")
      v-btn.font-weight-bold.text-capitalize.px-8(
        :href="path",
        color="primary",
        depressed
      ) Clique aqui
    v-img.mx-auto(:src="files + content.img", max-width="100%", contain)
</template>

<script>
const _config = {
  title: "WEB CANAL<br>DA ESCOLA",
  mod: "webcanal",
  path: "/web-canal",
};

export default {
  data: () => ({
    title: _config.title,
    path: _config.path,
  }),
  computed: {
    content() {
      return this.$rest(_config.mod).item;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod).get({
      save: (state, data) => (state.item = data),
    });
  },
};
</script>

<style>
</style>
